// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineArrowSwapHorizontal = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.4897 20.7599C15.2997 20.7599 15.1097 20.6899 14.9597 20.5399C14.6697 20.2499 14.6697 19.7699 14.9597 19.4799L19.9697 14.4699C20.2597 14.1799 20.7397 14.1799 21.0297 14.4699C21.3197 14.7599 21.3197 15.2399 21.0297 15.5299L16.0197 20.5399C15.8697 20.6799 15.6797 20.7599 15.4897 20.7599Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.5 15.7402H3.5C3.09 15.7402 2.75 15.4002 2.75 14.9902C2.75 14.5802 3.09 14.2402 3.5 14.2402H20.5C20.91 14.2402 21.25 14.5802 21.25 14.9902C21.25 15.4002 20.91 15.7402 20.5 15.7402Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.49945 9.75994C3.30945 9.75994 3.11945 9.68994 2.96945 9.53994C2.67945 9.24994 2.67945 8.76994 2.96945 8.47994L7.97945 3.46994C8.26945 3.17994 8.74945 3.17994 9.03945 3.46994C9.32945 3.75994 9.32945 4.23994 9.03945 4.52994L4.02945 9.53994C3.88945 9.67994 3.68945 9.75994 3.49945 9.75994Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.5 9.75977H3.5C3.09 9.75977 2.75 9.41977 2.75 9.00977C2.75 8.59977 3.09 8.25977 3.5 8.25977H20.5C20.91 8.25977 21.25 8.59977 21.25 9.00977C21.25 9.41977 20.91 9.75977 20.5 9.75977Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineArrowSwapHorizontal };
